import * as React from 'react';
import * as styles from './TourLabel.css';
import { Icon3DTour16 } from '@cian/ui-kit';

export const TourLabel: React.FC = () => {
  return (
    <div className={styles['tour-label']}>
      <Icon3DTour16 color="white_100" />
    </div>
  );
};
